import React from "react";
import css from "./CoachMark.module.scss";
import { coachmark_pin, pointer } from "../../Images/Icons";
import { NavLink } from "react-router-dom";

const CoachMarkStep9 = (props) => {
    return (
        <div style={{ position: "relative" }}>
            <div className={css.backdrop_with_img}>
                <div className={css.higlight9}>
                    <div className={css.point}>
                        <img src={coachmark_pin}/>
                    </div>
                    
                    <div className={css.content}>                    
                        <i class="fi fi-rr-cross-small"></i>
                        <div className={css.title}>🔋 Explore Battery Insights!</div>
                        <div className={css.desc}>This section provides essential information about your battery, including capacity and charge status.</div>
                        <div className={css.step}>9/10</div>
                        <NavLink to="/home/statistic">
                            <button className={css.prev} onClick={props.prev}>Previous</button>
                        </NavLink>
                        <NavLink to="/home" onClick={props.next}>
                            <button className={css.next}>Next</button>
                        </NavLink>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default CoachMarkStep9;
